export default __webpack_public_path__ + "static/placeholder-15fe6acb1b153daa9046c3d2f80db114.jpg";